import { ChangeEvent, MouseEvent, useState, SyntheticEvent, useEffect } from 'react'

import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import Grid from '@mui/material/Grid'
import Link from '@mui/material/Link'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import CardHeader from '@mui/material/CardHeader'
import InputLabel from '@mui/material/InputLabel'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import CardContent from '@mui/material/CardContent'
import FormControl from '@mui/material/FormControl'
import OutlinedInput from '@mui/material/OutlinedInput'
import InputAdornment from '@mui/material/InputAdornment'
import FormHelperText from '@mui/material/FormHelperText'

import EyeOutline from 'mdi-material-ui/EyeOutline'
import EyeOffOutline from 'mdi-material-ui/EyeOffOutline'
import { ChannelType, channelDefault } from 'src/types/apps/channelTypes'
import * as Yup from 'yup';
import { Formik, Form, Field, ErrorMessage, useFormik } from 'formik'
import axios from '../services/ApiService'
import FormControlLabel from '@mui/material/FormControlLabel'
import Switch from '@mui/material/Switch'
import Autocomplete from '@mui/material/Autocomplete'
import Select, { SelectChangeEvent } from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
//import { countries } from 'src/@fake-db/autocomplete'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Icon } from '@iconify/react';
import Avatar from '@mui/material/Avatar'
import Checkbox from '@mui/material/Checkbox'
import { InvitationState } from '../types/enums/ApplicationEnum'
import toast from 'react-hot-toast'
import { CardActions, Container, Input, useTheme } from '@mui/material'

interface CountryType {
    code: string
    label: string
    phone: string
}


interface State {
    firstname: string,
    lastname: string,
    email: string,
    adminAccess: boolean
}

const InviteForm = () => {
    // ** States
    const [values, setValues] = useState<State>({
        firstname: '',
        lastname: '',
        email: '',
        adminAccess: false
    })

    const [allChannels, setAllChannels] = useState<ChannelType[]>();
    const [selectedChannels, setSelectedChannels] = useState<ChannelType[]>();
    const [anyChannelsAvailableForSelection, setAnyChannelsAvailableForSelection] = useState<boolean>(true);
    const [currentlySelectedChannel, setCurrentlySelectedChannel] = useState<ChannelType>();
    const [channelAccessLevel, setChannelAccessLevel] = useState<number>(0);
    const [channelAccessLevelError, setChannelAccessLevelError] = useState<string>();
    const [currentlySelectedChannelError, setCurrentlySelectedChannelError] = useState<string>();
    const [allChannelsChecked, setAllChannelsChecked] = useState<boolean>(false);

    const theme = useTheme();
    const resetFormState = () => {
        setSelectedChannels([]);
        formik.setFieldValue("firstname", "");
        formik.setFieldValue("lastname", "");
        formik.setFieldValue("email", "");
        formik.setFieldValue("adminAccess", false);
    }

    useEffect(() => {
        if (selectedChannels && selectedChannels.length
            && allChannels && allChannels.length
            && allChannels.length == selectedChannels.length) {
            setAnyChannelsAvailableForSelection(false);
        }
        else {
            setAnyChannelsAvailableForSelection(true);
        }
    }, [allChannels, selectedChannels]);

    useEffect(() => {
        axios.get('invite/GetEligibleChannelsForInvite').then((data: any) => setAllChannels(data.data));
    }, [])

    const inviteFormSchema = Yup.object().shape({
        firstname: Yup.string()
            .required('First Name is required'),
        lastname: Yup.string()
            .required('Last Name is required'),
        email: Yup.string().email()
            .required('Email is required')
    });

    const formik = useFormik({
        initialValues: {
            firstname: '',
            lastname: '',
            email: '',
            adminAccess: false,
        },
        validationSchema: inviteFormSchema,
        onSubmit: (values, { setSubmitting, resetForm }) => {
            setSubmitting(true);
            let channels = selectedChannels?.map(s => ({ channelId: s.id, channelAccessId: s.channelAccessId }));
            let objToPost = { ...values, channels: channels };
            axios.post('invite', JSON.stringify(objToPost)).then((response) => {
                setSubmitting(false);
                if (response.data && response.data.messages) {
                    let message = response.data.messages[InvitationState.ExistingUserInviteApplied];
                    if (message) {
                        toast.success(message)
                    }
                    resetForm();
                    resetFormState();
                }
                else {
                    toast.error("Something went wrong");
                }
                //Redirect user to some page or keep user on this one??
                //window.location.replace(ApplicationPaths.Login);
            });
        }
    });

    const appendChannel = () => {
        let error = false;
        if (!channelAccessLevel) {
            setChannelAccessLevelError("Access Level is required");
            error = true;
        }
        if (!currentlySelectedChannel) {
            setCurrentlySelectedChannelError("Channel is required");
            error = true;
        }
        if (error) {
            return;
        }
        let filteredChannel = allChannels?.filter(ac => ac.id == currentlySelectedChannel?.id)[0];
        if (filteredChannel) {
            filteredChannel = { ...filteredChannel, channelAccessId: channelAccessLevel };
        }

        if (filteredChannel && selectedChannels) {
            setSelectedChannels([...selectedChannels, filteredChannel]);
        }
        else {
            if (filteredChannel) {
                setSelectedChannels([filteredChannel]);
            }
        }
        setCurrentlySelectedChannel(undefined);
        setChannelAccessLevel(0);
    }

    const removeChannel = (channel: any) => {
        const filteredChannels = selectedChannels?.filter(ac => ac.id != channel.id);
        setSelectedChannels(filteredChannels);
    }
    let countries: CountryType[] = [
        { code: '1', label: 'PK', phone: '0292020' }
        , { code: '90', label: 'CH', phone: '0292020' }
        , { code: '2', label: 'US', phone: '0292020' }];

    interface CountryType {
        code: string
        label: string
        phone: string
    }

    const UpdateSelectedChannels = (channel: ChannelType, checked: boolean) => {
        if (checked) {
            if (selectedChannels && allChannels)
                setSelectedChannels([...selectedChannels, { ...allChannels?.filter(ac => ac.id == channel.id)[0], channelAccessId: 2 }]);
            else
                allChannels && setSelectedChannels([{ ...allChannels?.filter(ac => ac.id == channel.id)[0], channelAccessId: 2 }]);
            //selectedChannels = selectedChannels.concat(allChannels.filter(ac => ac.id == channel.id)[0]);
        }
        else {
            if (selectedChannels) {
                let channelsToSet = selectedChannels.filter(s => {
                    if (s.id != channel.id) {
                        return { ...s, channelAccessId: 2 }
                    }
                })
                channelsToSet && setSelectedChannels(channelsToSet);
            }
            setAllChannelsChecked(false);
        }
    }

    const SelectedChannelsTable = () => {
        return (
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                    <TableHead>
                        <TableRow>
                            <TableCell><FormControlLabel label='' control={<Checkbox name='color-info' color='info' onChange={(e, checked) => {
                                setAllChannelsChecked(checked);
                                checked ? allChannels && setSelectedChannels(allChannels.map((s) => ({ ...s, channelAccessId: 2 }))) :
                                    setSelectedChannels([])
                            }}
                                checked={allChannelsChecked}
                            />
                            }
                            /></TableCell>
                            <TableCell>&nbsp;</TableCell>
                            <TableCell>Name</TableCell>
                            <TableCell align="left">Description</TableCell>
                            <TableCell style={{ textTransform: 'none' }} align="left">
                                <FormControl variant='standard'>
                                    <Select labelId='demo-simple-select-label'
                                        size={"small"}
                                        onChange={(event: SelectChangeEvent) => {
                                            setSelectedChannels(selectedChannels?.map(p => ({ ...p, channelAccessId: +event.target.value })));
                                            setChannelAccessLevel(+event.target.value);
                                        }}
                                        value={channelAccessLevel?.toString()}
                                    >
                                        <MenuItem value={1}>Full Posting Access</MenuItem>
                                        <MenuItem value={2}>Approval Required</MenuItem>
                                    </Select>
                                </FormControl>
                            </TableCell>
                            {/*                            <TableCell align="left">&nbsp;</TableCell>*/}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {allChannels?.map((row) => (
                            <TableRow
                                key={row.name}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell align="left">
                                    <FormControlLabel label='' control={
                                        <Checkbox checked={selectedChannels && selectedChannels.some((p) => p.id == row.id)}
                                            onChange={(e, checked) => UpdateSelectedChannels(row, checked)}
                                            name='color-info'
                                            color='info' />} />
                                </TableCell>
                                <TableCell align="left">
                                    <Avatar src={row.profileImageUrl} sx={{ width: 30, height: 30, display: 'inline-flex' }} />
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    {row.name}
                                    {/*<img src={row.profileImageUrl}></img>*/}
                                </TableCell>
                                <TableCell align="left">{row.description}</TableCell>
                                <TableCell align="left">
                                    <FormControl variant='standard'>
                                        <Select labelId='demo-simple-select-label'
                                            size={"small"}
                                            onChange={(event: SelectChangeEvent) => {
                                                if (selectedChannels?.some((p) => p.id == row.id)) {
                                                    setChannelAccessLevel(0);
                                                    setSelectedChannels(selectedChannels?.map(ac => {
                                                        if (ac.id == row.id) {
                                                            return { ...ac, channelAccessId: +event.target.value }
                                                        }
                                                        else {
                                                            return ac;
                                                        }
                                                    }));
                                                }
                                            }
                                            }
                                            value={selectedChannels ? selectedChannels.filter(ac => ac.id == row.id)[0]?.channelAccessId?.toString() : ""}
                                            disabled={!selectedChannels?.some((p) => p.id == row.id)}
                                        >
                                            <MenuItem value={1}>Full Posting Access</MenuItem>
                                            <MenuItem value={2}>Approval Required</MenuItem>
                                        </Select>
                                    </FormControl>
                                </TableCell>
                                {/*<TableCell align="left">*/}
                                {/*    <Icon icon="material-symbols:delete-sharp" style={{ fontSize: '24px', cursor: 'pointer' }}*/}
                                {/*        onClick={() => removeChannel(row)}*/}
                                {/*    />*/}
                                {/*</TableCell>*/}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        );
    }

    const ChannelAssignment = () => {

        return (
            <Grid container spacing={5} className={'ml-3'}>
                <Grid item xs={3}>
                    <ChannelsSelectionDD />
                </Grid>
                <Grid item xs={3}>
                    <FormControl variant='standard'>
                        <InputLabel id='demo-simple-select-label'>Access Level</InputLabel>
                        <Select label='Access Level' labelId='demo-simple-select-label'
                            onChange={(event: SelectChangeEvent) => {
                                setChannelAccessLevel(+event.target.value)
                                setChannelAccessLevelError(undefined);
                            }
                            }
                            value={channelAccessLevel.toString()}
                        >
                            <MenuItem value={1}>Full Posting Access</MenuItem>
                            <MenuItem value={2}>Approval Required</MenuItem>
                        </Select>
                        {
                            channelAccessLevelError &&
                            <Typography variant="subtitle2" color="error">
                                {channelAccessLevelError}
                            </Typography>
                        }
                    </FormControl>
                </Grid>
                <Grid item xs={2}>
                    <Button variant='outlined' onClick={appendChannel}>Add</Button>
                </Grid>
            </Grid>
        )
    }

    const ChannelsSelectionDD = () => {
        const excludedItems: ChannelType[] = [];
        const bIds = new Set(selectedChannels && selectedChannels.map(item => item.id));

        const filteredItemsA = allChannels && allChannels.filter(item => {
            if (!bIds.has(item.id)) {
                return true;
            } else {
                excludedItems.push(item);
                return false;
            }
        });

        return (
            <FormControl variant='standard'>
                <Autocomplete
                    autoHighlight
                    sx={{ width: 250 }}
                    size={'small'}
                    id='autocomplete-channel-select'
                    options={filteredItemsA as ChannelType[]}
                    getOptionLabel={option => option.name}
                    onChange={(e, val) => {
                        val && setCurrentlySelectedChannel(val)
                        setCurrentlySelectedChannelError(undefined);
                    }}
                    value={currentlySelectedChannel}
                    renderOption={(props, option) => (
                        <Box component='li' sx={{ '& > img': { mr: 4, flexShrink: 0 } }} {...props}>
                            <Avatar src={option.profileImageUrl} sx={{ width: 20, height: 20 }} />
                            &nbsp;{option.name}
                        </Box>
                    )}
                    renderInput={params => (
                        <TextField
                            {...params}
                            sx={{ marginTop: '2px' }}
                            variant='standard'
                            label='Choose a Channel'
                            inputProps={{
                                ...params.inputProps,
                                autoComplete: 'new-password'
                            }}
                        />
                    )}
                />
                {
                    currentlySelectedChannelError &&
                    <Typography variant="subtitle2" color="error">
                        {currentlySelectedChannelError}
                    </Typography>
                }

            </FormControl>
        )
    }


    return (
        <Container maxWidth="xl">
            <Typography variant='h4' sx={{ fontWeight: 'bold', color: 'text.primary', mt: 2 }}>
                Invite Users
            </Typography>
            <Typography variant='body2' color='textSecondary'>
                Invite new users to join our social media management platform. They'll receive an email
                with instructions to set up their account.
            </Typography>
            <Card sx={{ backgroundColor: theme.palette.background.paper, mt: 6 }}>
                <CardHeader
                    title={
                        <Typography variant='h5' sx={{ fontWeight: 'bold' }}>
                            Enter user/s details
                        </Typography>
                    }
                    subheader={
                        <Typography variant='body2' color='textSecondary'>
                            Fill the required fields below and/or toggle admin access, to invite users to your workspace
                        </Typography>
                    }
                />
                <form onSubmit={formik.handleSubmit}>
                    <CardContent>
                        <Grid container spacing={4}>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth variant='standard'>
                                    <InputLabel htmlFor='firstname'>First Name</InputLabel>
                                    <Input
                                        id='firstname'
                                        name='firstname'
                                        value={formik.values.firstname}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        error={formik.touched.firstname && Boolean(formik.errors.firstname)}
                                    />
                                    {formik.touched.firstname && formik.errors.firstname && (
                                        <Typography variant='caption' color='error'>
                                            {formik.errors.firstname}
                                        </Typography>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth variant='standard'>
                                    <InputLabel htmlFor='lastname'>Last Name</InputLabel>
                                    <Input
                                        id='lastname'
                                        name='lastname'
                                        value={formik.values.lastname}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        error={formik.touched.lastname && Boolean(formik.errors.lastname)}
                                    />
                                    {formik.touched.lastname && formik.errors.lastname && (
                                        <Typography variant='caption' color='error'>
                                            {formik.errors.lastname}
                                        </Typography>
                                    )}
                                </FormControl>
                            </Grid>
                        </Grid>

                        <FormControl fullWidth variant='standard' sx={{ mt: 4 }}>
                            <InputLabel htmlFor='email'>Email</InputLabel>
                            <Input
                                id='email'
                                name='email'
                                type='email'
                                value={formik.values.email}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.email && Boolean(formik.errors.email)}
                            />
                            {formik.touched.email && formik.errors.email && (
                                <Typography variant='caption' color='error'>
                                    {formik.errors.email}
                                </Typography>
                            )}
                        </FormControl>

                        <FormControlLabel
                            control={
                                <Switch
                                    checked={formik.values.adminAccess}
                                    onChange={formik.handleChange}
                                    name='adminAccess'
                                    color='primary'
                                />
                            }
                            label='Administrator Access'
                            sx={{ mt: 2 }}
                        />

                        {/* Selected Channels Table */}
                        {allChannels && allChannels.length > 0 && <SelectedChannelsTable />}
                    </CardContent>
                    <CardActions sx={{ justifyContent: 'flex-end', p: 2, m: 2 }}>
                        <Button type='submit' variant='contained' color='primary' disabled={formik.isSubmitting}>
                            Invite User
                        </Button>
                    </CardActions>
                </form>
            </Card>
        </Container>
    )
}

export default InviteForm
